import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../config/index';

console.log(process.env.NODE_ENV);
console.log(config);

export default class checkBox extends Component {
  constructor(props) {
    super(props);
    var elements = this.props.checkBoxElements;
    var elementMap = {};
    for(var i=0;i<elements.length;i++){
      var key = "element"+i;
      elementMap[key]={
        tag:elements[i],
        active:false
      };
    }
    this.elementList=elementMap;
    this.state = {
      trigger: false
    };

    this.triggetNext = this.triggetNext.bind(this);
  }

  elementList={};

  onChange = (element) => event => {
    console.log("on change: ",element," ",this.elementList[element]);
    this.elementList[element].active = !this.elementList[element].active; 
  }

  submitForm(){
    const {steps} = this.props;
    var result = this.props.result;
    if(steps["nameQuery"])
      result["name"] = steps["nameQuery"].value;
    
    if(steps["emailQuery"])
      result["email"]=steps["emailQuery"].value
    if(steps['heightQuery'])
      result["height"] = steps["heightQuery"].value
    if(steps["weightQuery"])  
      result["weight"] = steps["weightQuery"].value
    if(steps["ageQuery"])
      result["age"] = steps["ageQuery"].value
    if(steps["genderQuery"])  
      result["gender"] = steps["genderQuery"].value
    if(steps["singleselectQuery1"])
      result["singleselectQuery1"] = {value:steps["singleselectQuery1"].value,message:steps["8"].message};
    if(steps["singleselectQuery2"])
      result["singleselectQuery2"] = {value:steps["singleselectQuery2"].value,message:steps["9"].message};
    if(steps["singleselectQuery3"])
      result["singleselectQuery3"] = {value:steps["singleselectQuery3"].value,message:steps["11"].message};
    if(steps["singleselectQuery4"])
      result["singleselectQuery4"] = {value:steps["singleselectQuery4"].value,message:steps["12"].message};
    if(steps["singleselectQuery5"])
      result["singleselectQuery5"] = {value:steps["singleselectQuery5"].value,message:steps["15"].message};
    console.log("result is: ",result);
  }

  onSubmit = async (e) => {
    e.preventDefault();
    if(this.props.end){
        this.submitForm();
    }
    else{
      this.props.populateResults(this.props.queryName,this.elementList);      
      this.triggetNext();
    }
  }

  triggetNext() {
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep();
    });
  }

  componentDidMount() {
    console.log("component mounted");
  }

  counter=-1;
  render() {
    var _this=this;
    return (<div id= 'renderCheckBox' style={{backgroundColor: "#f0f5ff", padding: "inherit"}}>
      <form onSubmit={_this.onSubmit}>
        {
        _this.props.checkBoxElements.map(function(element){
          _this.counter++;
          var idName = "element"+_this.counter;
          return (
          <div className="form-check"><label className="form-check-label"><p style={{"fontWeight": "350", "fontSize": "16px"}}><input type="checkbox"  onChange={_this.onChange(idName)} className="form-check-input" />{element}</p></label></div>
        )})
        }
        <div className="form-group"><button className="btn btn-success" style={{width:"100px",height: "45px",backgroundColor: "#3961f8", border: "none", color: "white", padding: "0px 10px", textAlign: "center", display: "inline-block", fontSize: "16px", margin: "4px 2px", cursor: "pointer", borderRadius: "30px", paddingTop:"9px"}}><p style={{"fontWeight": "bold", "fontSize": "16px"}}>Submit</p></button></div>
      </form>
    </div>);
  }
}

checkBox.propTypes = {
  steps: PropTypes.object,
  triggerNextStep: PropTypes.func
};

checkBox.defaultProps = {
  steps: undefined,
  triggerNextStep: undefined
};